export const SIDE_NAV = {
  photo_report: {
    uk: "Фото звіт",
    en: "Photo report",
  },
  all_reports: {
    uk: "Bсі звіти",
    en: "All reports",
  },
  merchandiser: {
    uk: "Мерчендайзер",
    en: "Merchandiser",
  },
  tasks: {
    uk: "Завдання",
    en: "Tasks",
  },
  my_uploads: {
    uk: "Мої завантаження",
    en: "My Uploads",
  },
  answers: {
    uk: "Відповіді",
    en: "Answers",
  },
  task_uploading: {
    uk: "Завантаження завдань",
    en: "Task uploading",
  },
  points: {
    uk: "Точки",
    en: "Points",
  },
  visit: {
    uk: "Візити",
    en: "Visits",
  },
  documents: {
    uk: "Документи",
    en: "Documents",
  },
  logout: {
    uk: "Вихід",
    en: "Logout",
  },
};
export const MANAGER_PROFILE = {
  my_profile: {
    uk: "Мій профайл",
    en: "My profile",
  },
  my_help: {
    uk: "Допомога",
    en: "Help",
  },
  name: {
    uk: "Імя",
    en: "Name",
  },
  surname: {
    uk: "Прізвище",
    en: "Surname",
  },
  position: {
    uk: "Посада",
    en: "Position",
  },
  my_region: {
    uk: "Мій регіон",
    en: "My region",
  },
  telegram: {
    uk: "Телеграм ID",
    en: "Telegram ID",
  },
  language: {
    uk: "Мова",
    en: "Language",
  },
  save: {
    uk: "Зберегти",
    en: "Save",
  },
  save_success: {
    uk: "Дані успішно збережені",
    en: "Data saved successfully",
  },
  save_success_reload: {
    uk: "Дані успішно збережені. Сторінка буде перезавантажена...",
    en: "Data saved successfully. The page will be reloaded...",
  },
  exit: {
    uk: "Вихід",
    en: "Logout",
  },
};
export const ENTITY_DROPDOWN_SETTINGS = {
  custom_filter: {
    uk: "Користувацький фільтр",
    en: "Customer filter",
  },
  merchandiser: {
    uk: "Мерчендайзер",
    en: "Merchandiser",
  },
  merchandisers: {
    uk: "Мерчендайзери",
    en: "Merchandisers",
  },
  supervisor: {
    uk: "Супервайзер",
    en: "Supervisor",
  },
  clients: {
    uk: "Клієнти",
    en: "clients",
  },
  comment: {
    uk: "Коментар ...",
    en: "Comment ...",
  },
  point: {
    uk: "Точка",
    en: "Point",
  },
  points: {
    uk: "Точки",
    en: "Points",
  },
  group_point_select_placeholder: {
    uk: "Група точок",
    en: "Group of points",
  },
  network: {
    uk: "Мережа",
    en: "Network",
  },
  networks: {
    uk: "Мережі",
    en: "Networks",
  },
  created_by: {
    uk: "Ким створено",
    en: "Created by",
  },
  region: {
    uk: "Регіон",
    en: "Region",
  },
  city: {
    uk: "Місто",
    en: "City",
  },
  brand: {
    uk: "Бренд",
    en: "Brand",
  },
  brands: {
    uk: "Бренди",
    en: "Brands",
  },
  product: {
    uk: "Продукт",
    en: "Product",
  },
  products: {
    uk: "Продукти",
    en: "Products",
  },
  category: {
    uk: "Категорія",
    en: "Category",
  },
  categories: {
    uk: "Категорії",
    en: "Сategories",
  },
  subcategories: {
    uk: "Підкатегорія",
    en: "Sub category",
  },
  tag: {
    uk: "Тег",
    en: "Tag",
  },
  tags: {
    uk: "Теги",
    en: "Tags",
  },
  component: {
    uk: "Компонент",
    en: "Сomponent",
  },
  template: {
    uk: "Шаблон",
    en: "Template",
  },
  task_status: {
    uk: "Статус: всі",
    en: "Status: all",
  },
  task_negative: {
    uk: "Негативна відповідь",
    en: "Negative answer",
  },
  task_deadline: {
    uk: "Дедлайн",
    en: "Deadline",
  },
  additional_filters: {
    uk: "Додаткові фільтри",
    en: "Additional filters",
  },
  apply: {
    uk: "Застосувати",
    en: "Apply",
  },
  filter_reset: {
    uk: "Скинути фільтри",
    en: "Reset the filters",
  },
  filter_save: {
    uk: "Зберегти фільтр",
    en: "Save the filter",
  },
  filter_remove: {
    uk: "Видалити фільтр",
    en: "Remove the filter",
  },
  filter_name_placeholder: {
    uk: "Назва фільтру",
    en: "Filter name",
  },
  date_range: {
    uk: "Виберіть період",
    en: "Select a certain period",
  },
  date_today: {
    uk: "Сьогодні",
    en: "Today",
  },
  date_yesterday: {
    uk: "Вчора",
    en: "Yesterday",
  },
  date_current_week: {
    uk: "Поточний тиждень",
    en: "Current week",
  },
  date_last_week: {
    uk: "Попередній тиждень",
    en: "Last week",
  },
  date_сurrent_month: {
    uk: "Поточний місяць",
    en: "Current month",
  },
  date_last_month: {
    uk: "Попередній місяць",
    en: "Last month",
  },
  date_last_half_year: {
    uk: "Останні пів року",
    en: "Last half a year",
  },
  photo_review_type_group: {
    uk: "Груповий вигляд",
    en: "View Group",
  },
  photo_review_type_single: {
    uk: "Індивідуальний вигляд",
    en: "View Single",
  },
};
export const TRANSLATION_DOWNLOADER = {
  export: {
    uk: "Експортувати",
    en: "Export",
  },
  download: {
    uk: "Скачати",
    en: "Download",
  },
  downloadAll: {
    uk: "Скачати всі",
    en: "Download All",
  },
  downloading: {
    uk: "Завантаження",
    en: "Downloading",
  },
  confirmation_msg: {
    uk: "Ви впевненні що хочете видалити фільтр?",
    en: "Are you sure that you want to delete the filter?",
  },
  remove_confirmation_msg: {
    uk: "Потрібно вибрати фільтр для видалення",
    en: "Need to select a filter to delete",
  },
  remove_success_msg: {
    uk: "Фільтр видалений",
    en: "The filter is deleted",
  },
  valid_error_msg: {
    uk: "Ім'я фільтра не може бути пустим!",
    en: "The filter's name cannot be empty!",
  },
  newtask_success_msg: {
    uk: "Завдання зберeжене",
    en: "The task is saved",
  },

  task_object_item_id_msg: {
    uk: "object_id або object_type не знайдені",
    en: "object_id or object_type not found",
  },
  task_reject_msg: {
    uk: "Відхиленно",
    en: "Rejection",
  },
  task_accept_msg: {
    uk: "Затвердженно",
    en: "Approval",
  },
  back: {
    uk: "Назад",
    en: "Back",
  },
  yes: {
    uk: "Так",
    en: "Yes",
  },
  cancel: {
    uk: "Відмінити",
    en: "Cancel",
  },
};
export const ENTITY_TABLE = {
  records_count: {
    uk: "Кількість записів",
    en: "Records count",
  },
  start_date: {
    uk: "Дата початку",
    en: "Start date",
  },
  deadline_date: {
    uk: "Дата дедлайна",
    en: "Deadline date",
  },
  filter_overdue_tasks: {
    uk: "Відфільтрувати простроковані задачі",
    en: "Filter overdue tasks",
  },
  filter_tasks_with_negative_responses: {
    uk: "Відфільтрувати задачі з негативними відповідями",
    en: "Filter tasks with negative responses",
  },
  creation_date_from: {
    uk: "Дата створення з",
    en: "Creation date from",
  },
  creation_date_to: {
    uk: "Дата створення по",
    en: "Creation date to",
  },
  search_placeholder: {
    uk: "Пошук ...",
    en: "Search ...",
  },
  filter_reset_btn: {
    uk: "Скинути фільтри",
    en: "Reset filters",
  },
  create_btn: {
    uk: "Створити",
    en: "Create",
  },
  to_point_btn: {
    uk: "на точку",
    en: "to point",
  },
  to_network_btn: {
    uk: "на мережу",
    en: "to network",
  },
  apply_btn: {
    uk: "Застосувати",
    en: "Apply",
  },
};
export const MERCHANDISER_EDITOR = {
  name: {
    uk: "Імя",
    en: "Name",
  },
  date_of_enrollment: {
    uk: "Дата приєднання",
    en: "Date of joining",
  },
  deactivation_date: {
    uk: "Дата деактивації",
    en: "Deactivation date",
  },
  date_till_newbie: {
    uk: "Дата до новачка",
    en: "Date till newbie",
  },
  surname: {
    uk: "Прізвище",
    en: "Surname",
  },
  phone_number: {
    uk: "Телефон",
    en: "Phone number",
  },
  movement: {
    uk: "Пересування",
    en: "Movement",
  },
  password: {
    uk: "Пароль",
    en: "Password",
  },
  repeat_password: {
    uk: "Повторити пароль",
    en: "Repeat password",
  },
  status: {
    uk: "Статус",
    en: "Status",
  },
  save_changes_btn: {
    uk: "Зберегти зміни",
    en: "Save changes",
  },
};
export const MERCHANDISER_MAIN_PAGE = {
  data_successfully_saved: {
    uk: "Дані успішно збережені",
    en: "Data successfully saved",
  },
  view_btn: {
    uk: "Перегляд",
    en: "View",
  },
  edit_btn: {
    uk: "Редагувати",
    en: "Edit",
  },
  route: {
    uk: "Маршрут",
    en: "Route",
  },
  assignment: {
    uk: "ЗАВДАННЯ",
    en: "Assignment",
  },
  visits: {
    uk: "ВІЗИТИ",
    en: "VISITS",
  },
  presence: {
    uk: "ВІДСУТНІСТЬ",
    en: "PRESENCE",
  },
  network_title: {
    uk: "Мережа",
    en: "Network",
  },
  title_title: {
    uk: "Титул",
    en: "Title",
  },
  start_title: {
    uk: "Срт",
    en: "Start",
  },
  end_title: {
    uk: "Кінець",
    en: "End",
  },
  number_of_images_title: {
    uk: "Кількість зображень",
    en: "Number of images",
  },
  number_of_tags_title: {
    uk: "Кількість тегів",
    en: "Number of tags",
  },
  completion_title: {
    uk: "Закінчення",
    en: "Completion",
  },
  point_title: {
    uk: "Точка",
    en: "Point",
  },
  points_title: {
    uk: "Точки",
    en: "Points",
  },
  day_title: {
    uk: "День",
    en: "Day",
  },
  save_btn: {
    uk: "Зберегти",
    en: "Save",
  },
  movement: {
    uk: "Пересування",
    en: "Movement",
  },
  connected: {
    uk: "Приєднався",
    en: "Connected",
  },
  deactivated: {
    uk: "Деактивований",
    en: "Deactivated",
  },
  till_newbie: {
    uk: "До новачків",
    en: "Till Newbie",
  },
  user_status: {
    uk: "Статус",
    en: "Status",
  },
};
export const MERCHANDISER_LIST = {
  user_name: {
    uk: "Ім'я користувача",
    en: "User name",
  },
  phone_number: {
    uk: "Телефон",
    en: "Phone",
  },
  movement: {
    uk: "Пересування",
    en: "Movement",
  },
  user_state: {
    uk: "Стан",
    en: "User State",
  },
  date_join: {
    uk: "Дата приєднання",
    en: "Date of joining",
  },
};
export const ABSENCE_USER = {
  query: {
    uk: "Запит",
    en: "Request",
  },
  date_from: {
    uk: "Дата з",
    en: "Date from",
  },
  date_to: {
    uk: "Дата до",
    en: "Date to",
  },
  reason: {
    uk: "Причина",
    en: "Reason",
  },
  add_btn: {
    uk: "Додати",
    en: "Add",
  },
  absence_history: {
    uk: "Історія відсутностей",
    en: "Absence history",
  },
  absence_reason: {
    uk: "Будь ласка, введіть причину відсутності",
    en: "Please enter the reason of absence",
  },
  absence_short_reason_title: {
    uk: "Варіанти швидких причин відсутності",
    en: "Quick absence reasons",
  },
  absence_short_reason: {
    uk: "Виберіть швидкий варіант причини відсутності",
    en: "You can choose a quick reason for absence",
  },
};
export const WEEK = {
  monday: {
    uk: "Понеділок",
    en: "Monday",
  },
  tuesday: {
    uk: "Вівторок",
    en: "Tuesday",
  },
  wednesday: {
    uk: "Середа",
    en: "Wednesday",
  },
  thursday: {
    uk: "Четвер",
    en: "Thursday",
  },
  friday: {
    uk: "Пятниця",
    en: "Friday",
  },
  saturday: {
    uk: "Субота",
    en: "Saturday",
  },
  sunday: {
    uk: "Неділя",
    en: "Sunday",
  },
};
export const TAKS_LIST = {
  point: {
    uk: "Точка",
    en: "Point",
  },
  created_by: {
    uk: "Ким створено",
    en: "Created by",
  },
  supervisor: {
    uk: "Супервайзер",
    en: "Supervisor",
  },
  merchendiser: {
    uk: "Мерчендайзер",
    en: "Merchendiser",
  },
  name: {
    uk: "Назва",
    en: "Name",
  },
  task_title: {
    uk: "Титул",
    en: "Title",
  },
  task_group_points_title: {
    uk: "Титул завантаження",
    en: "Upload title",
  },
  finishing: {
    uk: "Закінчення",
    en: "Finishing",
  },
  status: {
    uk: "Статус",
    en: "Status",
  },
  date_creation: {
    uk: "Дата створення",
    en: "Date of creation",
  },
  print_report: {
    uk: "Друкувати звіт",
    en: "Print report",
  },
  responses: {
    uk: "Відповіді",
    en: "Responses",
  },
  first_page: {
    uk: "Перша",
    en: "First",
  },
  previous_page: {
    uk: "Попередня",
    en: "Previous",
  },
  next_page: {
    uk: "Наступна",
    en: "Next",
  },
  last_page: {
    uk: "Остання",
    en: "Last",
  },
  description: {
    uk: "Опис",
    en: "Description",
  },
  addresses: {
    uk: "Адреса",
    en: "Addresses",
  },
  network: {
    uk: "Мережа",
    en: "Network",
  },
  answer_saved: {
    uk: "Відповідь збережена",
    en: "The answer is saved",
  },
  task_saved: {
    uk: "Завдання збережене",
    en: "The task is saved",
  },
  date_saved: {
    uk: "Дані успішно збережені",
    en: "The data is successfully saved",
  },
  download_btn: {
    uk: "Завантажити",
    en: "Download",
  },
  approv_btn: {
    uk: "Затвердити",
    en: "To approve",
  },
  reject_btn: {
    uk: "Відхилити",
    en: "Reject",
  },
  remove_btn: {
    uk: "Видалити",
    en: "Remove",
  },
  cancel_btn: {
    uk: "Відмінити",
    en: "Cancel",
  },
  back_btn: {
    uk: "Назад",
    en: "Back",
  },
  task_details_title: {
    uk: "Деталі завдання",
    en: "Details of the task",
  },
  task_created_by_err_msg: {
    uk: "Видалити завдання може тільки її автор",
    en: "Remove the task can only be done by its author",
  },
  new_task_group_btn_text: {
    uk: "На групу точок",
    en: "Per group of points",
  },
  new_task_single_btn_text: {
    uk: "На точку",
    en: "Per one point",
  },
  yes: {
    uk: "так",
    en: "yes",
  },
  no: {
    uk: "ні",
    en: "no",
  },
};
export const TAKS_NEW = {
  drag_msg: {
    uk: "Клікніть або перетягніть зображення сюди",
    en: "Click or drag the image here",
  },
  new_order: {
    uk: "Нове доручення",
    en: "New order",
  },
  group_point_label: {
    uk: "Група точок",
    en: "Group of points",
  },
  task_template: {
    uk: "Шаблон",
    en: "Template",
  },
  start_date: {
    uk: "Дата початку",
    en: "The start date",
  },
  end_date: {
    uk: "Дата закінчення",
    en: "The end date",
  },
  save_btn: {
    uk: "Зберегти",
    en: "Save",
  },
};
export const TAKS_REVIEW = {
  apply_btn: {
    uk: "Застосувати",
    en: "Apply",
  },
  reject_btn: {
    uk: "Відхилити",
    en: "Reject",
  },
  reset_filters_btn: {
    uk: "Скинути фільтри",
    en: "Reset the filters",
  },
  records_count: {
    uk: "Кількість записів",
    en: "Records count",
  },
  point: {
    uk: "Точка",
    en: "Point",
  },
  network: {
    uk: "Мережа",
    en: "Network",
  },
  priority: {
    uk: "Пріоритет",
    en: "Priority",
  },
  merchandiser: {
    uk: "Мерчендайзер",
    en: "Merchandiser",
  },
  responsible_supervisor: {
    uk: "Відповідальний супервайзер",
    en: "Responsible supervisor",
  },
  supervisor: {
    uk: "Супервайзер",
    en: "Supervisor",
  },
  view_btn: {
    uk: "Перегляд",
    en: "View",
  },
  photo_title: {
    uk: "Фото",
    en: "Photo",
  },
  details_task: {
    uk: "Деталі Завдання",
    en: "Details of the task",
  },
  title_task: {
    uk: "Титул",
    en: "Title",
  },
  description_task: {
    uk: "Опис завдання",
    en: "Description of the task",
  },
  tags_task: {
    uk: "Теги",
    en: "Tags",
  },
  images_task: {
    uk: "Зображення",
    en: "Images",
  },
  deadline_task: {
    uk: "Дедлайн",
    en: "Deadline",
  },
  details_response_task: {
    uk: "Деталі Відповіді",
    en: "Response Details",
  },
  date_response_task: {
    uk: "Дата відповіді",
    en: "Response Date",
  },
  text_response_task: {
    uk: "Текст відповіді",
    en: "Response Text",
  },
  photo_response_task: {
    uk: "Фото відповіді",
    en: "Response Photo",
  },
  yes: {
    uk: "Так",
    en: "Yes",
  },
  no: {
    uk: "Ні",
    en: "No",
  },
  visit_id: {
    uk: "Номер Візиту",
    en: "Visit ID",
  },
  back_btn: {
    uk: "Назад",
    en: "Back",
  },
};
export const TAKS_IMPORT = {
  import_tab: {
    uk: "Імпорт",
    en: "Import",
  },
  import_advanced_tab: {
    uk: "Розширений імпорт",
    en: "Advanced Import",
  },
  import_matrix_tab: {
    uk: "Імпорт: асортимента матриця",
    en: "Import: Assortment Matrix",
  },
  import_downloads_tab: {
    uk: "Мої завантаження",
    en: "My Uploads",
  },
  type_loading: {
    uk: "Тип завантаження",
    en: "Loading Type",
  },
  click_or_drag_file: {
    uk: "Клікніть або перетягніть файл",
    en: "Click or Drag a File",
  },
  download_btn: {
    uk: "Завантажити",
    en: "Download",
  },
  add_record_btn: {
    uk: "Додати запис",
    en: "Add Record",
  },
  save_btn: {
    uk: "Зберегти",
    en: "Save",
  },
  back_btn: {
    uk: "Назад",
    en: "Back",
  },
  status: {
    uk: "Статус",
    en: "Status",
  },
  name_title: {
    uk: "Назва",
    en: "Name",
  },
  line_title: {
    uk: "Рядок",
    en: "Line",
  },
  start_date_title: {
    uk: "Дата початку",
    en: "Start Date",
  },
  end_date_title: {
    uk: "Дата кінця",
    en: "End Date",
  },
  photo_title: {
    uk: "Фото",
    en: "Photo",
  },
  description_title: {
    uk: "Опис",
    en: "Description",
  },
  added_points_text_label_suf: {
    uk: "Додано",
    en: "Added",
  },
  added_points_text_label_pref: {
    uk: "точка(точок)",
    en: "point(points)",
  },
  type_tasks_title: {
    uk: "Тип задач",
    en: "Type of tasks",
  },
  download_date_title: {
    uk: "Дата завантаження",
    en: "Download date",
  },
  loading_errors_title: {
    uk: "Помилки завантаження",
    en: "Loading errors",
  },
  need_title_task_msg: {
    uk: "Потрібно ввести титул завдання",
    en: "You need to enter the title of the task",
  },
  download_was_delete_msg: {
    uk: "Завантаження успішно видалено",
    en: "Download has been successfully deleted",
  },
  need_choose_task_msg: {
    uk: "Потрібно вибрати шаблон",
    en: "You need to choose a template",
  },
  need_choose_point_msg: {
    uk: "Потрібно вибрати точку",
    en: "Point is required field",
  },
  need_choose_point_group_msg: {
    uk: "Потрібно вибрати групу точок",
    en: "Group of points is required field",
  },
  create_success_group_task_msg: {
    uk: "Ваші завдання створюються та будуть готові за кілька хвилин.",
    en: "Creating your tasks. They will be ready in a couple of minutes.",
  },
  need_choose_point_group_name_msg: {
    uk: "Потрібно ввести титул завантаження",
    en: "Group of points title is required field",
  },
  empty_field_msg: {
    uk: "Це поле не може бути пустим",
    en: "This field cannot be empty",
  },
  download_name: {
    uk: "Назва завантаження",
    en: "Download name",
  },
  select_download_type: {
    uk: "Оберіть типа завантаження",
    en: "Choose the download type",
  },
  click_drag_img: {
    uk: "Клікніть або перетягніть зображення сюди",
    en: "Click or drag the image here",
  },
  only_one_photo_allowed_for_type_point: {
    uk: "Для типу завантаження 'Точка' дозволене лише одне фото",
    en: "For upload type 'Point', only one photo is allowed",
  },
  complete_at_least_one_task_msg: {
    uk: "Заповніть хоча б одне завдання або виберіть файл для імпорту",
    en: "Complete at least one task or select a file to import",
  },
  network_label: {
    uk: "Мережа",
    en: "Network",
  },
  point_label: {
    uk: "Точка",
    en: "Point",
  },
  remove_btn: {
    uk: "Видалити",
    en: "Remove",
  },
  addresses_label: {
    uk: "Адреса",
    en: "Addresses",
  },
  code_label: {
    uk: "Код",
    en: "Code",
  },
  location_label: {
    uk: "Розташування",
    en: "Location",
  },
  coordinates_label: {
    uk: "Координати",
    en: "Coordinates",
  },
  view_the_point: {
    uk: "Перегляд точки",
    en: "View the point",
  },
  grouping_btn_name: {
    uk: "Групування",
    en: "Grouping",
  },
  new_group_btn_name: {
    uk: "Нова група",
    en: "New Group",
  },
  grouping_popup_title: {
    uk: "Групування торгових точок",
    en: "Grouping of trade points",
  },
  new_group_popup_title: {
    uk: "Існуючі групи",
    en: "Existing groups",
  },
  new_group_popup_new_title: {
    uk: "Створення нової групи",
    en: "Creating a new group",
  },
  new_group_popup_edit_title: {
    uk: "Редагування групи",
    en: "Editing group",
  },
  new_group_popup_field_name: {
    uk: "Назва групи",
    en: "Group Name",
  },
  new_group_popup_field_group_textarea_name: {
    uk: "Торгові точки",
    en: "Trade points",
  },
  group_popup_filter_name_label: {
    uk: "Фільтр точок",
    en: "Points filter",
  },
  new_group_popup_field_group_available_users: {
    uk: "Доступно для",
    en: "Available for",
  },
  new_group_popup_field_name_placeholder: {
    uk: "Введіть назву групи. Мінімум 5 символів",
    en: "Enter the name of the group. Minimum 5 characters",
  },
  group_popup_filter_name_placeholder: {
    uk: "Фільтрування торгових точок (мін 3 символи)",
    en: "Filtering trade points (min 3 characters)",
  },
  new_group_popup_field_group_add_all_btn_text: {
    uk: "Додати всі точки",
    en: "Add all points",
  },
  new_group_popup_field_group_placeholder: {
    uk: "Виберіть торгові точки зі списку",
    en: "Choose trade points from the list",
  },
  group_popup_filter_name_empty_placeholder: {
    uk: "Торгових точок що відповідають вашому фільтру не знайдено",
    en: "No trade points matching your filter were found.",
  },
  new_group_popup_field_users_placeholder: {
    uk: "Виберіть кому доступна група зі списку",
    en: "Choose who has access to the group from the list",
  },
  new_group_popup_error_text: {
    uk: "Поле не може бути пустим",
    en: "The field cannot be empty",
  },
  new_group_popup_error_text_minimum: {
    uk: "Мінімум 5 символів",
    en: "Minimum 5 characters",
  },
  new_group_popup_success_save_text: {
    uk: "Успішно збережено",
    en: "Successfully saved",
  },
  new_group_popup_success_deleted_text: {
    uk: "Успішно видалено",
    en: "Successfully deleted",
  },
  new_group_popup_failed_deleted_text: {
    uk: "Помилка видалення, дивіться деталі в консолі",
    en: "Failed to delete, check the console",
  },
  new_group_popup_user_validate_error_text: {
    uk: "У вас немає дозволу для виконання цієї дії",
    en: "You do not have permission to perform this action.",
  },
  new_group_popup_error_save_text: {
    uk: "Помилка створення нової группи",
    en: "Error creating a new group",
  },
  new_group_popup_error_update_text: {
    uk: "Помилка оновлення группи",
    en: "Error updating group",
  },
  new_group_popup_delete_approve_text: {
    uk: "Ви впевнені, що хочете видалити?",
    en: "Are you sure you want to delete?",
  },
  new_group_popup_btn_save_name: {
    uk: "Зберегти",
    en: "Save",
  },
  no_group_found_msg: {
    uk: "Жодна група не знайдена",
    en: "No group found",
  },
  selected_point_row_has_error: {
    uk: "При виборі точки виникла помилка",
    en: "An error occurred while selecting the point",
  },
  file_successfully_uploaded: {
    uk: "Файл успішно завантажений",
    en: "File Successfully Uploaded",
  },
  file_error_uploaded: {
    uk: "Виникла помилка при загрузці файла",
    en: "An error occurred while loading the file.",
  },
  import_group_dragdrop_label: {
    uk: "Клікніть або перетягніть файл сюди або виберіть торгові точки зі списку",
    en: "Click or drag the file here or select the trade points from the list",
  },
  import_group_dragdrop_approve_file_text: {
    uk: "Тільки .csv,.xlsx файл",
    en: "Only .csv,.xlsx file",
  },
  confirm_clear_all_points_before_change: {
    uk: "Ви додали всі поінти. Очистити список та продовжити? (ОК — очистити, Скасувати — залишити)",
    en: "You added all points. Clear the list and proceed? (OK — clear, Cancel — keep)",
  },
  confirm_reset_or_keep_points: {
    uk: "В списку є вибрані поінти. Додати нові до існуючих? (ОК — додати до існуючих, Скасувати — скинути)",
    en: "Points exist in the list. Add new ones to existing? (OK — add to existing, Cancel — reset)",
  },
  confirm_clear_all_points_before_change: {
    uk: "Ви додали всі поінти. Очистити список та продовжити? (ОК — очистити, Скасувати — залишити)",
    en: "You added all points. Clear the list and proceed? (OK — clear, Cancel — keep)",
  },
  confirm_reset_or_keep_points: {
    uk: "В списку є вибрані поінти. Додати нові до існуючих? (ОК — додати до існуючих, Скасувати — скинути)",
    en: "Points exist in the list. Add new ones to existing? (OK — add to existing, Cancel — reset)",
  },
};
export const DOCUMENTS = {
  file_deleted: {
    uk: "Файл видалений",
    en: "File Deleted",
  },
  file_name_cannot_be_empty: {
    uk: "Ім'я файлу не може бути пустим",
    en: "File Name Cannot Be Empty",
  },
  need_to_add_file: {
    uk: "Потрібно додати файл",
    en: "Need to Add File",
  },
  file_successfully_uploaded: {
    uk: "Файл успішно завантажений",
    en: "File Successfully Uploaded",
  },
  add_file: {
    uk: "Додати файл",
    en: "Add File",
  },
  file_name: {
    uk: "Назва файлу",
    en: "File Name",
  },
  click_or_drag_files_here: {
    uk: "Клікніть або перетягніть файли сюди",
    en: "Click or Drag Files Here",
  },
  download_file_btn: {
    uk: "Завантажити файл",
    en: "Download File",
  },
  creation_time: {
    uk: "Час створення",
    en: "Creation Time",
  },
};
export const PHOTO_REVIEW = {
  merchendiser: {
    uk: "Мерчендайзер",
    en: "Merchendiser",
  },
  responsible_supervisor: {
    uk: "Відповідальний супервайзер",
    en: "Responsible supervisor",
  },
  start_visit: {
    uk: "Старт візиту",
    en: "The start of the visit",
  },
  end_visit: {
    uk: "Кінець візиту",
    en: "The end of the visit",
  },
  comment: {
    uk: "Коментар",
    en: "Comment",
  },
  price: {
    uk: "Ціна",
    en: "Price",
  },
  sales_price: {
    uk: "Ціна продажу",
    en: "Sales price",
  },
  price_monitoring: {
    uk: "Моніторинг цін",
    en: "Price monitoring",
  },
  approve_reject_label_block: {
    uk: "Статус затвердження/відхилення",
    en: "Approval/Rejection Status",
  },
  approv_btn: {
    uk: "Затвердити",
    en: "To approve",
  },
  reject_btn: {
    uk: "Відхилити",
    en: "Reject",
  },
  approved_by: {
    uk: "Затверджено",
    en: "Approved by",
  },
  rejected_by: {
    uk: "Відхилено",
    en: "Rejected by",
  },
  app_reject_date: {
    uk: "Дата",
    en: "Date",
  },
  answer: {
    uk: "Відповідь",
    en: "Answer",
  },
  linkedTasks: {
    uk: "Повязані задачі",
    en: "Linked tasks",
  },
  linkedVisit: {
    uk: "Візит",
    en: "Visit",
  },
  description: {
    uk: "Опис",
    en: "Description",
  },
  yes: {
    uk: "Так",
    en: "Yes",
  },
  no: {
    uk: "Ні",
    en: "No",
  },
  created_by: {
    uk: "Ким створено",
    en: "Created by",
  },
  priority: {
    uk: "Пріорітет",
    en: "Priority",
  },
  status: {
    uk: "Статус",
    en: "Status",
  },
  approved: {
    uk: "Затверджено",
    en: "Approved",
  },
  rejected: {
    uk: "Відхілено",
    en: "Rejected",
  },
};
export const USER_LOGIN = {
  login_success_msg: {
    uk: "Ви успішно увійшли в систему",
    en: "You have successfully logged in to the system",
  },
  login_error_msg: {
    uk: "Користувач не існує або неправильні дані для входу.",
    en: "User does not exist or incorrect login data.",
  },
};
export const VISIT_PAGE = {
  page_title: {
    uk: "Візити",
    en: "Visits",
  },
  table_timespent: {
    uk: "Час",
    en: "Time",
  },
  author_way: {
    uk: "Автор/По маршруту",
    en: "Author/On the route",
  },
  merchandiser: {
    uk: "Мерчендайзер",
    en: "Merchandiser",
  },
  supervisor: {
    uk: "Супервайзер",
    en: "Supervisor",
  },
  approved_by: {
    uk: "Затверджено",
    en: "Approved by",
  },
  point: {
    uk: "Точка",
    en: "Point",
  },
  point_started_title: {
    uk: "Розпочато",
    en: "Started",
  },
  point_agoby_title: {
    uk: "тому",
    en: "ago by",
  },
  seconds: {
    uk: "секунд",
    en: "seconds",
  },
  minutes: {
    uk: "хвилин",
    en: "minutes",
  },
  hours: {
    uk: "годин",
    en: "hours",
  },
  days: {
    uk: "днів",
    en: "days",
  },
  months: {
    uk: "місяців",
    en: "months",
  },
  years: {
    uk: "років",
    en: "years",
  },
  status_label: {
    uk: "Статус",
    en: "Status",
  },
  progress_label: {
    uk: "Прогрес, %",
    en: "Progress, %",
  },
  approved_label_popup: {
    uk: "Затверджено",
    en: "Approved",
  },
  pending_label_popup: {
    uk: "На затверджені",
    en: "Pending",
  },
  rejected_label_popup: {
    uk: "Не виконані",
    en: "Not executed",
  },
  approved_single_visit_name: {
    uk: "Затверджено",
    en: "Approved",
  },
  no_approved_single_visit_name: {
    uk: "Не затверджено",
    en: "Not approved",
  },
  on_verification_single_visit_name: {
    uk: "На перевірці",
    en: "On verification",
  },
  back_to_btn_label: {
    uk: "Повернутися до візитів",
    en: "Back to visits",
  },
  orders_tab_name: {
    uk: "Замовлення",
    en: "Orders",
  },
  returns_tab_name: {
    uk: "Повернення",
    en: "Returns",
  },
  payments_tab_name: {
    uk: "Платежі",
    en: "Payments",
  },
  zvit_tab_name: {
    uk: "Звіти",
    en: "Reports",
  },
  task_tab_name: {
    uk: "Задачі",
    en: "Tasks",
  },
  monitoring_tab_name: {
    uk: "Моніторинг",
    en: "Monitoring",
  },
  log_tab_name: {
    uk: "Журнал подій",
    en: "Event log",
  },
  surveys_tab_name: {
    uk: "Опитування",
    en: "Surveys",
  },
  surveys_summary_surveys_label: {
    uk: "Опитування",
    en: "Surveys",
  },
  surveys_summary_answers_label: {
    uk: "Відповіді",
    en: "Answers",
  },
  surveys_summary_photos_label: {
    uk: "Фото",
    en: "Photos",
  },
  surveys_tab_products: {
    uk: "Товари",
    en: "Products",
  },
  surveys_tab_brands: {
    uk: "Бренди",
    en: "Brands",
  },
  surveys_tab_categories: {
    uk: "Категорії",
    en: "Categories",
  },
  surveys_tab_other: {
    uk: "Інше",
    en: "Other",
  },
  surveys_answer_type_bool: {
    uk: "Так/Ні",
    en: "Bool",
  },
  surveys_answer_type_numeric: {
    uk: "Число",
    en: "Numeric",
  },
  surveys_answer_type_dropdown: {
    uk: "Список",
    en: "Dropdown",
  },
  surveys_answer_type_text: {
    uk: "Текст",
    en: "Text",
  },
  surveys_answer_type_date: {
    uk: "Дата",
    en: "Date",
  },
  surveys_answer_type_photo: {
    uk: "Фото",
    en: "Photo",
  },
  surveys_answer_bool_yes: {
    uk: "Так",
    en: "Yes",
  },
  surveys_answer_bool_no: {
    uk: "Ні",
    en: "No",
  },
  surveys_photo_label: {
    uk: "фото",
    en: "photos",
  },
  surveys_empty_products: {
    uk: "Немає питань по товарах",
    en: "No product questions",
  },
  surveys_empty_brands: {
    uk: "Немає питань по брендах",
    en: "No brand questions",
  },
  surveys_empty_categories: {
    uk: "Немає питань по категоріях",
    en: "No category questions",
  },
  surveys_empty_other: {
    uk: "Немає інших питань",
    en: "No other questions",
  },
  surveys_modal_close: {
    uk: "Закрити",
    en: "Close",
  },
  surveys_search_placeholder: {
    uk: "Пошук опитування…",
    en: "Search survey…",
  },
  surveys_reset_btn: {
    uk: "Скинути",
    en: "Reset",
  },
  surveys_entity_search_placeholder: {
    uk: "Пошук…",
    en: "Search…",
  },
  surveys_no_results: {
    uk: "Нічого не знайдено за запитом",
    en: "No results found",
  },
  surveys_show_more: {
    uk: "Показати ще",
    en: "Show more",
  },
  task_has_empty_error: {
    uk: "Будь ласка, виберіть хоча б один ітем",
    en: "Please select at least one item",
  },
  task_has_answer_error: {
    uk: "Задача немає відповіді",
    en: "The task has no answer",
  },
  approv_task_product_btn: {
    uk: "Затвердити продукт",
    en: "To approve the product",
  },
  reject_task_product_btn: {
    uk: "Відхилити продукт",
    en: "Reject the product",
  },
  approv_task_btn: {
    uk: "Затвердити задачу",
    en: "To approve the task",
  },
  reject_task_btn: {
    uk: "Відхилити задачу",
    en: "Reject the task",
  },
  approv_btn: {
    uk: "Затвердити",
    en: "To approve",
  },
  reject_btn: {
    uk: "Відхилити",
    en: "Reject",
  },
  task_tab_type_label: {
    uk: "Тип",
    en: "Type",
  },
  task_tab_task_name_label: {
    uk: "Назва задачі",
    en: "Name of the task",
  },
  task_tab_info_label: {
    uk: "Опис",
    en: "Description",
  },
  task_tab_deadline_label: {
    uk: "Дедлайн",
    en: "Deadline",
  },
  task_tab_createdby_label: {
    uk: "Ким створено",
    en: "Created by",
  },
  task_tab_count_photo_label: {
    uk: "Кількість фото",
    en: "Number of photos",
  },
  task_tab_status_label: {
    uk: "Статус",
    en: "Status",
  },
  task_tab_answer_status_yes_label: {
    uk: "Так",
    en: "Yes",
  },
  task_tab_answer_status_no_label: {
    uk: "Ні",
    en: "No",
  },
  task_tab_answer_status_label: {
    uk: "Відповідь",
    en: "Answer",
  },
  task_tab_answer_comment_label: {
    uk: "Коментар",
    en: "Comment ",
  },
  task_tab_answer_tags_label: {
    uk: "Теги",
    en: "Tags ",
  },
  approve_visit_msg: {
    uk: "Візит затверджено",
    en: "Visit approved",
  },
  already_approve_visit_msg: {
    uk: "Візит вже було затверджено",
    en: "Visit already approved",
  },
  reject_visit_msg: {
    uk: "Візит відхилено",
    en: "Visit rejected",
  },
  already_reject_visit_msg: {
    uk: "Візит вже було відхилено",
    en: "Visit already rejected",
  },
  monitoring_tab_pname_label: {
    uk: "Назва",
    en: "Name",
  },
  monitoring_tab_pcode_label: {
    uk: "Код продукту",
    en: "Product code",
  },
  monitoring_tab_price_label: {
    uk: "Ціна",
    en: "Price",
  },
  monitoring_tab_sale_price_label: {
    uk: "Ціна продажу",
    en: "Sale Price",
  },
  monitoring_tab_photo_label: {
    uk: "Фото",
    en: "Photo URL",
  },
  monitoring_tab_comment_label: {
    uk: "Коментар",
    en: "Comment",
  },
  monitoring_tab_event_monitoring_label: {
    uk: "Моніторинг",
    en: "Monitoring",
  },
  monitoring_tab_event_photos_in_answers_label: {
    uk: "Фото у відповідях",
    en: "Photos in answers",
  },
  monitoring_tab_event_photos_in_reports_label: {
    uk: "Фото у звітах",
    en: "Photos in reports",
  },
  monitoring_tab_event_reports_done_label: {
    uk: "Звітів виконано",
    en: "Reports done",
  },
  monitoring_tab_event_tasks_done_label: {
    uk: "Завдань виконано",
    en: "Tasks done",
  },
  monitoring_tab_event_tasks_not_done_label: {
    uk: "Завдань не виконано",
    en: "Tasks not done",
  },
  monitoring_tab_event_answers_not_supervised_label: {
    uk: "Відповідей не перевірено",
    en: "Answers not supervised",
  },
  monitoring_tab_event_answers_supervised_label: {
    uk: "Відповідей перевірено",
    en: "Answers supervised",
  },
  monitoring_tab_selected_label: {
    uk: "Обрано",
    en: "Selected",
  },
  orders_product_name: {
    uk: "Назва замовлення",
    en: "Order Name",
  },
  orders_product_status_changed: {
    uk: "Статус змінено",
    en: "Status changed ",
  },
  orders_product_status_date: {
    uk: "Дата",
    en: "Date",
  },
  orders_product_status: {
    uk: "Статус",
    en: "Status ",
  },
  orders_product_total: {
    uk: "Всього",
    en: "Total ",
  },
  orders_currency_total: {
    uk: "грн.",
    en: "grn.",
  },
  orders_popup_order_id_title: {
    uk: "ID замовлення",
    en: "Order ID",
  },
  orders_popup_details_title: {
    uk: "Деталі замовлення",
    en: "Order details",
  },
  orders_popup_sales_rep_label: {
    uk: "Торговий представник",
    en: "Sales Rep",
  },
  orders_popup_order_status_label: {
    uk: "Статус замовлення",
    en: "Order Status",
  },
  orders_popup_counterparty_label: {
    uk: "Контрагент",
    en: "Counterparty",
  },
  orders_popup_order_type_label: {
    uk: "Тип замовлення",
    en: "Order Type",
  },
  orders_popup_order_table_label: {
    uk: "Таблиця продуктів",
    en: "Products Table",
  },
  orders_popup_order_table_name: {
    uk: "Назва",
    en: "Name",
  },
  orders_popup_order_table_quantity: {
    uk: "Кількість",
    en: "Quantity",
  },
  orders_popup_order_table_amount: {
    uk: "Сума",
    en: "Amount",
  },
  orders_popup_created_time_label: {
    uk: "Дата та час створення",
    en: "Created Date & Time",
  },
  orders_popup_delivery_time_label: {
    uk: "Дата доставки",
    en: "Delivery Date",
  },
  orders_popup_tracked_geolocation_label: {
    uk: "Відстежена геолокація",
    en: "Tracked Geolocation",
  },
  orders_popup_custom_fields_label: {
    uk: "Користувацькі поля",
    en: "Custom Fields",
  },
  orders_popup_comment_label: {
    uk: "Коментар",
    en: "Comment",
  },
  orders_popup_visit_label: {
    uk: "Візит",
    en: "Visit",
  },
  orders_physical_return_label: {
    uk: "Дата фізичного повернення",
    en: "Physical Return Date",
  },
  orders_status_return_label: {
    uk: "Статус повернення",
    en: "Return Status",
  },
  orders_return_id_label: {
    uk: "ID повернення",
    en: "Return ID",
  },
  orders_return_crated_label: {
    uk: "Дата та час створення",
    en: "Created Date & Time",
  },
  orders_payment_id_label: {
    uk: "ID оплати",
    en: "Payment ID",
  },
  orders_payment_amount_label: {
    uk: "Сума",
    en: "Amount",
  },
  orders_payment_debt_label: {
    uk: "Борг",
    en: "Debt",
  },
};
